import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useEffect } from 'react';
import c from 'classnames';
import ScrollableContent from '@wix/da-ds/pkg/ScrollableContent';
import { useBodyScrollLock } from '@wix/da-ds/pkg/hooks/useBodyScrollLock';
import { setRefs } from '@wix/da-shared-react/pkg/utils/refHelpers';
import s from './FeedScrollableContainer.scss';
const FeedScrollableContainer = (_param)=>{
    var { children, innerRef: suppliedInnerRef, className } = _param, rest = _object_without_properties(_param, [
        "children",
        "innerRef",
        "className"
    ]);
    const { onLock, onUnlock, setScrollableRef, scrollableElementRef } = useBodyScrollLock();
    useEffect(()=>{
        return ()=>onUnlock();
    }, [
        onUnlock
    ]);
    const innerRefCallback = useCallback((r)=>{
        if (!scrollableElementRef.current) {
            setScrollableRef(r);
            onLock();
        }
    }, [
        onLock,
        scrollableElementRef,
        setScrollableRef
    ]);
    return /*#__PURE__*/ React.createElement(ScrollableContent, _object_spread({
        className: c(s['scrollable'], className),
        wrapperClassName: s['scrollable-wrapper'],
        innerRef: (node)=>setRefs([
                innerRefCallback,
                suppliedInnerRef
            ], node)
    }, rest), children);
};
FeedScrollableContainer.displayName = 'FeedScrollableContainer';
export default FeedScrollableContainer;

//# sourceMappingURL=FeedScrollableContainer.js.map